<template>
  <div>
    <my-notification :icon="'crosshairs'">
      <template #title>
        {{ $t('compScenarioScenarioEditor.title') }}
      </template>
      <p>
        <span v-html="$t('compScenarioScenarioEditor.info-1')" />
      </p>
    </my-notification>
    <br />
    <div class="columns">
      <div class="column is-4">
        <b-notification :closable="false">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ scenario.ghgi.year }}
              </p>
              <div class="title is-size-4">
                <p>
                  {{ totalGHGI | splitNumberTons }}
                  <span class="is-size-6">{{ $t('t.co2e') }}</span>
                </p>
              </div>
            </div>
          </div>
        </b-notification>
        <b-carousel
          v-if="ghgi"
          v-model="carouselValue"
          :autoplay="false"
          indicator-style="is-lines"
          :indicator-inside="true"
        >
          <b-carousel-item>
            <ghgi-pie
              :height="250"
              :enabledLabels="false"
              :ghgi="ghgi"
              titleSize="14px"
              :exporting="false"
              :modules="modules"
              :colors="colors"
            />
          </b-carousel-item>
          <b-carousel-item>
            <ghgi-bar
              :height="250"
              :enabledLabels="false"
              :ghgi="ghgi"
              :exporting="false"
              :modules="modules"
              :colors="colors"
            />
          </b-carousel-item>
          <b-carousel-item>
            <ghgi-tree-map
              :height="250"
              :enabledLabels="false"
              :ghgi="ghgi"
              titleSize="14px"
              :exporting="false"
              :modules="modules"
              :colors="colors"
            />
          </b-carousel-item>
        </b-carousel>
      </div>
      <div class="column is-4">
        <b-notification :closable="false">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ scenario.timeline }}
              </p>
              <div class="title is-size-4">
                <p>
                  {{ totalScenario | splitNumberTons }}
                  <span class="is-size-6">{{ $t('t.co2e') }}</span>
                </p>
              </div>
            </div>
          </div>
        </b-notification>
        <b-carousel
          v-if="scenario"
          v-model="carouselValue"
          :autoplay="false"
          indicator-style="is-lines"
          :indicator-inside="true"
        >
          <b-carousel-item>
            <ghgi-pie
              :height="250"
              :enabledLabels="false"
              :results="scenario.ghgi.emissions"
              :ghgi="scenario.ghgi"
              titleSize="14px"
              :exporting="false"
              :modules="modules"
              :colors="colors"
            />
          </b-carousel-item>
          <b-carousel-item>
            <ghgi-bar
              :height="250"
              :enabledLabels="false"
              :results="scenario.ghgi.emissions"
              :ghgi="scenario.ghgi"
              :exporting="false"
              :modules="modules"
              :colors="colors"
            />
          </b-carousel-item>
          <b-carousel-item>
            <ghgi-tree-map
              :height="250"
              :enabledLabels="false"
              :results="scenario.ghgi.emissions"
              :ghgi="scenario.ghgi"
              titleSize="14px"
              :exporting="false"
              :modules="modules"
              :colors="colors"
            />
          </b-carousel-item>
        </b-carousel>
      </div>
      <div class="column is-4">
        <b-notification :closable="false">
          <div class="level-item has-text-centered">
            <div>
              <p class="heading">
                {{ $t('compScenarioScenarioEditor.label-3') }}
              </p>
              <div class="title is-size-4">
                <p>{{ scenario.reductionRate }} %</p>
              </div>
            </div>
          </div>
        </b-notification>
        <b-carousel
          :autoplay="false"
          indicator-style="is-lines"
          :indicator-inside="true"
        >
          <b-carousel-item>
            <scenario-area
              :height="250"
              :ghgi="ghgi"
              :scenario="scenario"
              :exporting="false"
              :modules="modules"
              :colors="colors"
            />
          </b-carousel-item>
          <b-carousel-item>
            <scenario-pie
              :height="250"
              :ghgi="ghgi"
              titleSize="14px"
              :scenario="scenario"
              :exporting="false"
              :modules="modules"
              :colors="colors"
            />
          </b-carousel-item>
        </b-carousel>
      </div>
    </div>
    <!-- <draggable
      v-model="scenario.rules"
      @end="dragEnd"
      draggable=".rule"
    >
      <transition-group
        tag="div"
        class="columns is-multiline"
      >
        <div
          class="column rule is-4"
          v-for="rule in scenario.rules"
          :key="rule.id"
        >
          <rule
            :data="rule"
            :ghgi="ghgi"
            @input="compute"
            @close="removeRule"
            @update-level1="updateLevel1"
            @change-level1="changeLevel1"
            @update-level2="updateLevel2"
            @reset-level2="resetLevel2"
          />
        </div>
        <div
          class="column is-4"
          key="add-btn"
        >
          <label
            class="upload control is-expanded"
            @click="rulesModalActive=true"
          >
            <div class="upload-draggable is-info is-expanded">
              <section class="section rule-section">
                <div class="content has-text-centered">
                  <p>
                    <span class="icon">
                      <i class="fa fa-plus" style="font-size: 36px;"></i>
                    </span>
                  </p>
                  <p>{{ $t('compScenarioScenarioEditor.label-4') }}</p>
                </div>
              </section>
            </div>
          </label>
        </div>
      </transition-group>
    </draggable> -->
    <div class="columns is-multiline">
      <div class="column mt-3 is-4" key="add-btn">
        <label
          class="upload control is-expanded"
          @click="rulesModalActive = true"
        >
          <div class="upload-draggable is-info is-expanded">
            <section class="section rule-section">
              <div class="content has-text-centered">
                <p>
                  <span class="icon">
                    <i class="fa fa-plus" style="font-size: 36px"></i>
                  </span>
                </p>
                <p>{{ $t('compScenarioScenarioEditor.label-4') }}</p>
              </div>
            </section>
          </div>
        </label>
      </div>
      <div
        class="column mt-3 rule is-4"
        v-for="rule in scenario.rules"
        :key="rule.id"
      >
        <rule
          :data="rule"
          :ghgi="ghgi"
          @input="compute"
          @close="removeRule"
          @update-level1="updateLevel1"
          @change-level1="changeLevel1"
          @update-level2="updateLevel2"
          @reset-level2="resetLevel2"
        />
      </div>
      <rules-selector-modal
        @add="addRule"
        @close="rulesModalActive = false"
        :active.sync="rulesModalActive"
        :ghgi="ghgi"
        :scenario="scenario"
      />
    </div>
    <nav class="level" v-if="authStore.isAuthenticated && editable">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="buttons">
          <b-button
            class="level-item"
            icon-left="save"
            :disabled="!module.isModified"
            type="is-primary"
            @click="save"
          >
            {{ $t('save') }}
          </b-button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { useAdminStore } from '@/stores/admin.js'
import { useAuthenticationStore } from '@/stores/authentication.js'
import { useScenarioStore } from '@/stores/scenario.js'
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'ScenarioEditor',
  props: {
    module: {
      type: Object,
      default: null
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    rule: () => import('@/components/scenario/Rule.vue'),
    'my-notification': () => import('@/components/MyNotification.vue'),
    'scenario-area': () => import('@/components/graphics/ScenarioArea.vue'),
    'scenario-pie': () => import('@/components/graphics/ScenarioPie.vue'),
    'ghgi-pie': () => import('@/components/graphics/GHGIPie.vue'),
    'ghgi-bar': () => import('@/components/graphics/GHGIBar.vue'),
    'ghgi-tree-map': () => import('@/components/graphics/GHGITreeMap.vue'),
    // 'draggable': () => import('vuedraggable'),
    'rules-selector-modal': () =>
      import('@/components/scenario/RulesSelectorModal.vue')
  },
  data () {
    return {
      selectedYear: null,
      rulesModalActive: false,
      carouselValue: 0
    }
  },
  setup () {
    const adminStore = useAdminStore()
    const authStore = useAuthenticationStore()
    const scenarioStore = useScenarioStore()
    const coreStore = useCoreStore()
    return { adminStore, authStore, scenarioStore, coreStore }
  },
  computed: {
    modules: function () {
      return this.coreStore.activeModules(true)
    },
    colors: function () {
      return this.coreStore.modulesColors
    },
    scenario: function () {
      return this.scenarioStore.item
    },
    ghgi: function () {
      return this.adminStore.allGHGI.filter(
        (obj) => obj.year === this.scenario.ghgi.year
      )[0]
    },
    totalGHGI: function () {
      let totalGHGI = 0
      if (this.ghgi) {
        totalGHGI = this.ghgi.carbonSynthesis.intensity
      }
      return Math.round(totalGHGI)
    },
    totalScenario: function () {
      let totalScenario = 0
      if (this.scenario) {
        if (this.scenario.ghgi.emissions) {
          for (let key of Object.keys(this.scenario.ghgi.emissions)) {
            totalScenario +=
              this.scenario.ghgi.emissions[key].intensity.intensity
          }
        }
      }
      return totalScenario
    }
  },
  methods: {
    inputChanged () {
      this.$emit('is-valid', false)
      this.$emit('is-modified', true)
    },
    addRule (rule) {
      this.scenarioStore.addRule(rule)
      this.rulesModalActive = false
      this.compute(rule.module)
      this.inputChanged()
    },
    removeRule (rule) {
      this.scenarioStore.removeRule(rule)
      this.compute(rule.module)
      this.inputChanged()
    },
    dragEnd () {
      this.compute()
      this.inputChanged()
    },
    save () {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })
      this.scenarioStore
        .save(this.ghgi.id)
        .then((response) => {
          loadingComponent.close()
          window.scrollTo(0, 0)
          this.$buefy.toast.open({
            type: 'is-light',
            message: this.$t('compScenarioScenarioEditor.save-msg')
          })
          this.$emit('is-valid', true)
          this.$emit('is-modified', false)
          this.$router
            .push('/scenario-1point5/' + response.uuid)
            .catch(() => {})
        })
        .catch((erreur) => {
          loadingComponent.close()
          this.$emit('is-valid', false)
          this.$emit('is-modified', false)
        })
    },
    updateLevel1 (data) {
      this.scenarioStore.updateLevel1(data)
      this.compute(data.module)
    },
    changeLevel1 () {
      this.inputChanged()
    },
    updateLevel2 (data) {
      this.scenarioStore.updateLevel2(data)
      this.compute(data.module)
      this.inputChanged()
    },
    resetLevel2 (data) {
      this.scenarioStore.resetLevel2(data)
      this.compute(data.module)
      this.inputChanged()
    },
    compute (module = null) {
      this.scenarioStore.compute(module)
    }
  },
  mounted () {
    if (this.scenario.rules.length === 0) {
      this.$emit('is-valid', false)
      this.$emit('is-modified', false)
    }
    if (!this.authStore.isAuthenticated) {
      this.scenarioStore.setGHGI(this.adminStore.allGHGI[0])
    }
  }
}
</script>

<style scoped>
.upload .upload-draggable.is-expanded {
  height: 153px;
}
.notification.is-heatings {
  background-color: rgba(200, 72, 150, 0.1) !important;
}
.notification.is-electricity {
  background-color: rgba(232, 139, 195, 0.1) !important;
}
.notification.is-refrigerants {
  background-color: rgba(253, 194, 229, 0.1) !important;
}
.notification.is-vehicles {
  background-color: rgba(253, 142, 98, 0.1) !important;
}
.notification.is-travels {
  background-color: rgba(103, 195, 165, 0.1) !important;
}
.notification.is-commutes {
  background-color: rgba(142, 160, 204, 0.1) !important;
}
.notification.is-foods {
  background-color: #fbf7ef !important;
}
.notification.is-devices {
  background-color: rgba(166, 217, 83, 0.1) !important;
}
.notification.is-purchases {
  background-color: rgba(255, 218, 44, 0.1) !important;
}
.rule-section {
  padding: 27px;
}
</style>
